module.exports = __webpack_public_path__ + "img/logo_light.7e9858c5.png";